module.exports = __webpack_public_path__ + "img/btn_lijitixian@2x.03b7f073.gif";